"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EqualHousingOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29.47 11.12l-13-7a1 1 0 00-.94 0l-13 7a1 1 0 10.94 1.76L5 12.06V26a2 2 0 002 2h18a2 2 0 002-2V12.06l1.53.82a1 1 0 10.94-1.76zM25 11v15H7V11l9-4.84L25 11z"/><path d="M22 16a1 1 0 01-1 1H11a1 1 0 010-2h10a1 1 0 011 1zM22 20a1 1 0 01-1 1H11a1 1 0 010-2h10a1 1 0 011 1z"/>';
var EqualHousingOutlineSVG = function EqualHousingOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.EqualHousingOutlineSVG = EqualHousingOutlineSVG;
EqualHousingOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(EqualHousingOutlineSVG);
exports.default = _default;